export default {
  methods: {
    municipioSeletor(){
      if (Object.keys(this.meta.censo_domain).filter(ele => ele === document.location.host.replace("www.", "")).length > 0) {
        this.showMunicipioSelect = false
        this.selectedMunicipio = document.location.host.replace("www.", "")
        localStorage.setItem('selectedMunicipio', document.location.host.replace("www.", ""))
      } else {
        if(localStorage.selectedMunicipio){
          this.selectedMunicipio = localStorage.selectedMunicipio
        }
      }
    },
  }
}


// WEBPACK FOOTER //
// ./src/mixins/municipioSeletor.js